import React, { createContext, useState, useEffect } from "react";

export const CartContext = createContext();

const CartProvider = ({ children }) => {
  const [vendorId, setVendorId] = useState(() => localStorage.getItem("vendorId"));
  const [priceType, setPriceType] = useState(() => localStorage.getItem("priceType") || "sale");

  // Helper to load cart and apply sale pricing if available
  const loadCart = (vId, pType) => {

    const key = `cart_${vId}_${pType}`;
    const localCart = localStorage.getItem(key);
    const guestCart = localStorage.getItem('cart_null_sale');
    
    let storedCart;


    if (localCart !== '[]') {
      storedCart = localCart;
    } else if (guestCart !== '[]') {
      storedCart = guestCart
    } else {
      storedCart = localCart;
    }
    
    const pricingDataRaw = localStorage.getItem(`salePricing_${vId}`);
    const pricingData = pricingDataRaw ? JSON.parse(pricingDataRaw) : null;
  
    let salePricesMap = {};
    if (pType === "sale" && Array.isArray(pricingData)) {
      pricingData.forEach(pricingEntry => {
        if (Array.isArray(pricingEntry.items)) {
          pricingEntry.items.forEach(item => {
            if (item.menuItemId && item.salePrice != null) {
              salePricesMap[item.menuItemId] = item.salePrice;
            }
          });
        }
      });
    }
  
    console.log("Parsed salePricesMap:", salePricesMap);
  
    return storedCart ? JSON.parse(storedCart).map(item => {
      const originalPrice = item.originalPrice || item.price;
      const salePrice = (pType === "sale" && salePricesMap[item._id]) ? salePricesMap[item._id] : originalPrice;
      const finalPrice = salePrice;
  
      return {
        ...item,
        originalPrice,
        price: finalPrice,
        totalPrice: finalPrice * item.quantity,
        
      };

    }) : [];
  };

  const [cart, setCart] = useState(() => {
    if (vendorId) {
      return loadCart(vendorId, priceType);
    }
    return [];
  });

  useEffect(() => {
    // if (vendorId) {
      const key = `cart_${vendorId}_${priceType}`;
      console.log(`Saving cart to localStorage: ${key}`, cart);
      localStorage.setItem(key, JSON.stringify(cart));
    // }
  }, [cart, vendorId, priceType]);

  const setVendor = (id) => {
    localStorage.setItem("vendorId", id);
    setVendorId(id);
    const newCart = loadCart(id, priceType);
    setCart(newCart);
  };

  const changePriceType = (type) => {
    localStorage.setItem("priceType", type);
    setPriceType(type);
    if (vendorId) {
      const newCart = loadCart(vendorId, type);
      setCart(newCart);
    }
  };

  const addToCart = (item) => {
  console.log("Trying to add item to cart:", item);

  setCart((prev) => {
    // Only one restaurant allowed in 'purchase' priceType
    if (priceType === "purchase") {
      const existingRestaurantId = prev.length > 0 ? prev[0].restaurantId : null;
      if (existingRestaurantId && existingRestaurantId !== item.restaurantId) {
        alert("You can only add items from one restaurant in purchase mode.");
        return prev;
      }
    }

    // ✅ Check by id + packetSize (or default if undefined)
    const existingIndex = prev.findIndex((i) => i.cartKey === `${item.id}-${item.packetSize || "default"}`);

    if (existingIndex !== -1) {
      const updated = [...prev];
      updated[existingIndex] = {
        ...updated[existingIndex],
        quantity: item.quantity,
        totalPrice: item.price * item.quantity,
      };
      console.log("Updated existing item:", updated[existingIndex]);
      return updated;
    }

    const newItem = {
        ...item,
  name: item.packetSize ? `${item.name} (${item.packetSize})` : item.name,
  cartKey: `${item.id}-${item.packetSize || "default"}`, // ✅ unique identifier
  originalPrice: item.originalPrice || item.price,
  totalPrice: item.price * item.quantity,
    };
    console.log("Adding new item:", newItem);
    return [...prev, newItem];
  });
};


  const removeFromCart = (cartKey) => {
  setCart((prev) => prev.filter((i) => i.cartKey !== cartKey));
};



  const clearCart = () => {
    if (vendorId) {
      const key = `cart_${vendorId}_${priceType}`;
      localStorage.removeItem(key);
    }
    console.log("Cart cleared for vendor:", vendorId, "priceType:", priceType);
    setCart([]);
  };

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        removeFromCart,
        clearCart,
        setVendor,
        changePriceType,
        priceType,
        vendorId,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export default CartProvider;
